import React from 'react';
import { apiPaths } from 'app/services/api';
import DataView from '../../DataView/DataView';
import useAuth from 'app/hooks/useAuth';
import { daysBetween } from 'app/utils/utils';
// import {warrantyFields} from './WarrantyForm'
const warrantyFields = [
  { label: 'Warranty Number', key: 'warranty_number', validation: { required: true } },
  {
    label: 'Store',
    key: 'store_uuid',
    type: 'auto_complete',
    options: { entity: 'stores', path: apiPaths.STORES },
    // show: { key: 'type', value: 'organisational' },
  },
  { label: 'Customer', key: 'customer_name' },
  { label: 'Customer Number', key: 'customer_mobile_number' },
  { label: 'Brand', key: 'brand' },
  { label: 'Model', key: 'model' },
  { label: 'IMEI', key: 'imei' },
  { label: 'Price', key: 'total_price' },
  {
    label: 'can use change',
    key: 'paid_at',
    render: (row) => {
      const isFree = row?.total_price === 0;
      // const isFree = false;
      const shouldShow30Days = daysBetween(new Date(row?.paid_at), new Date()) < (isFree ? 7 : 30);
      return (
        <div>
          {shouldShow30Days ? (
            <span className="text-green-500">بله</span>
          ) : (
            <span className="text-red-500">خیر</span>
          )}
        </div>
      );
    },
  },
  { label: 'Pay Date', key: 'paid_at', type: 'date' },
  { label: 'Expiration Date', key: 'expires_at', type: 'date' },
  { label: 'Factor Picture', key: 'factor_picture', type: 'picture' },
  { label: 'Box Picture', key: 'box_picture', type: 'picture' },
];
const limitedWarrantyFields = [
  { label: 'Warranty Number', key: 'warranty_number', validation: { required: true } },
  {
    label: 'Store',
    key: 'store_uuid',
    type: 'auto_complete',
    options: { entity: 'stores', path: apiPaths.STORES },
  },
  { label: 'Brand', key: 'brand' },
  { label: 'Model', key: 'model' },
  { label: 'IMEI', key: 'imei' },
  { label: 'Date', key: 'created_at', type: 'date' },
  { label: 'Expiration', key: 'expires_at', type: 'date' },
  // {label: 'Factor Picture', key: 'factor_picture', type: 'picture'},
  // {label: 'Box Picture', key: 'box_picture', type: 'picture'},
];
const WarrantyView = () => {
  const { user } = useAuth();
  const showLimited = user.roles.includes('insurance_manager');

  return (
    <DataView
      apipath={apiPaths.WARRANTIES}
      columns={showLimited ? limitedWarrantyFields : warrantyFields}
    />
  );
};

export default WarrantyView;
